import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioNoNorming from 'assets/sounds/no/3 01 Tulleord Intro-norming.mp3';
import audioNnNorming from 'assets/sounds/nn/3 01 Tulleord Intro-norming.mp3';

import audioNo from 'assets/sounds/no/3 01 Tulleord Intro.mp3';
import audioNn from 'assets/sounds/nn/3 01 Tulleord Intro.mp3';

const languageObj = {
	no: audioNo,
	nn: audioNn,
};

const languageObjNorming = {
	no: audioNoNorming,
	nn: audioNnNorming,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.tulleordtestenIntro = this.props.isDldTest
			? strings.tulleordtestenIntroNorming
			: strings.tulleordtestenIntro;
		this.audio = this.props.isDldTest
			? languageObjNorming[strings.getLanguage()]
			: languageObj[strings.getLanguage()];

		this.tulleordtestenPractice = this.props.isDldTest
			? ''
			: strings.tulleordtestenPractice;
	}

	render() {
		const {onNextStep} = this.props;
		return (
			<div>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{this.tulleordtestenIntro}
				</p>
				<br />
				<p>{this.tulleordtestenPractice}</p>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
